// TODO: Read the value from the SDK, once we expose it
export const MINIMUM_BALANCE = BigInt(String(5e6)) // 0.05 BTC

export const SEASON_CAP = BigInt(String(5e10)) // 500 BTC
